<!-- HeatmapChart.vue -->
<script setup lang="ts">
import { computed, onMounted, PropType, ref } from "vue";

const props = defineProps({
  xLabels: { type: Array as PropType<string[]>, required: true },
  yLabels: { type: Array as PropType<string[]>, required: true },
  // each item: [xIndex, yIndex, value]
  data: { type: Array as PropType<[number, number, number][]>, required: true },
});

const primaryColor = ref("#4F7DF3"); // sensible fallback
const secondaryColor = ref("#4F7DF3"); // sensible fallback

onMounted(() => {
  const getPrimaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--color-primary")
    .trim();

  const getSecondaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--color-secondary")
    .trim();
  if (primaryColor) primaryColor.value = getPrimaryColor;
  if (getSecondaryColor) secondaryColor.value = getSecondaryColor;
});

const option = computed(() => ({
  tooltip: { position: "top" },
  grid: { height: "70%", top: "10%" },
  xAxis: {
    type: "category",
    data: props.xLabels,
    position: "top",
    splitArea: {
      show: true,
      areaStyle: {
        color: ["#F9FAFB"], // background for all cells, including empty ones
      },
    },
    axisLine: { show: false },
    axisTick: { show: false },
  },
  yAxis: {
    type: "category",
    data: props.yLabels,
    splitArea: {
      show: true,
      areaStyle: {
        color: ["#F9FAFB"],
      },
    },
    axisLine: { show: false },
    axisTick: { show: false },
  },
  visualMap: {
    min: 0,
    max: Math.max(...props.data.map((d) => d[2])),
    calculable: true,
    precision: 1,
    orient: "horizontal",
    left: "center",
    bottom: "0%",
    inRange: {
      color: [secondaryColor.value, primaryColor.value],
    },
  },
  series: [
    {
      type: "heatmap",
      data: props.data,
      label: { show: true },
      itemStyle: {
        borderColor: "#fff", // same border color/width as splitArea's border below
        borderWidth: 2,
      },
      emphasis: {
        itemStyle: { shadowBlur: 10, shadowColor: "rgba(0,0,0,0.5)" },
      },
    },
  ],
}));
</script>

<template>
  <VChart :option="option" autoresize />
</template>
